import gql from "graphql-tag";

export default gql`
  mutation UpdateSubdeployment($subdeploymentInput: SubdeploymentInputInput, $deploymentId: ID, $subdeploymentId: ID) {
    updateSubdeployment(subdeploymentInput: $subdeploymentInput, deploymentId: $deploymentId, subdeploymentId : $subdeploymentId) {
      id
    }
  }
`;